
import BookmarkAddIcon from "@mui/icons-material/BookmarkAdd";
import {
  Box,
  Button,
  Divider,
  Popover,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { SegmentFilterType } from "../../types/analytics";
import { Column } from "./types";

interface FilterPopoverProps {
  anchorEl: HTMLElement | null;
  column: Column | null;
  filterValue: string;
  onFilterChange: (value: string) => void;
  onClose: () => void;
  /** Optional: Map from column ID to segment filter type */
  columnToFilterType?: Record<string, SegmentFilterType | null>;
  /** Optional: Callback when user wants to create a segment from this filter */
  onCreateSegment?: (
    columnId: string,
    filterType: SegmentFilterType,
    value: string
  ) => void;
}

export const FilterPopover: React.FC<FilterPopoverProps> = ({
  anchorEl,
  column,
  filterValue,
  onFilterChange,
  onClose,
  columnToFilterType,
  onCreateSegment,
}) => {
  const canCreateSegment =
    column &&
    filterValue &&
    columnToFilterType &&
    onCreateSegment &&
    columnToFilterType[column.id] !== null &&
    columnToFilterType[column.id] !== undefined;

  const handleCreateSegment = () => {
    if (!column || !filterValue || !columnToFilterType || !onCreateSegment)
      return;
    const filterType = columnToFilterType[column.id];
    if (filterType) {
      onCreateSegment(column.id, filterType, filterValue);
      onClose();
    }
  };

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
    >
      <Box sx={{ p: 2, minWidth: 220 }}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Filter: {column?.label}
        </Typography>
        <TextField
          size="small"
          fullWidth
          placeholder="Type to filter..."
          value={filterValue}
          onChange={(e) => onFilterChange(e.target.value)}
          autoFocus
        />
        {canCreateSegment && (
          <>
            <Divider sx={{ my: 1.5 }} />
            <Stack spacing={1}>
              <Typography variant="caption" color="text.secondary">
                Save this filter as a reusable segment
              </Typography>
              <Button
                size="small"
                variant="outlined"
                startIcon={<BookmarkAddIcon />}
                onClick={handleCreateSegment}
                fullWidth
              >
                Create Segment
              </Button>
            </Stack>
          </>
        )}
      </Box>
    </Popover>
  );
};
